import {Injectable, OnInit} from '@angular/core';
import {constants} from '../app-constants';
import {PropertiesLocales} from '../util/properties-locale';
import {AdvGrowlService} from "primeng-advanced-growl";

@Injectable({
  providedIn: 'root'
})
export class MensagemService implements OnInit {

  public properties: PropertiesLocales = new PropertiesLocales();
  public message: any;
  public basePath: string;

  constructor(private advGrowlService: AdvGrowlService) {
  }

  ngOnInit() {
    this.loadProperties();
  }

  private loadProperties() {
    this.basePath = window.location.pathname;
    let local = localStorage.getItem(constants.locale);
    const uri = this.basePath.substring(7)
      .replace('/', '')
      .replace('/', '')
      .toString();

    if (local !== uri) { // prevalece o locale definido na URL
      local = uri;
    }

    switch (local) {
      case 'es':
        this.message = this.properties.items_steps_es;
        break;
      case 'en':
        this.message = this.properties.items_steps_en;
        break;
      default:
        this.message = this.properties.items_steps_pt;
        break;
    }
  }

  msgSucesso(msg: string) {
    if(!this.message) {
      this.loadProperties();
    }
    this.advGrowlService.createSuccessMessage( msg, this.message[14].msg_service_success);
  }

  getString(resource: string) {
    if(!this.message) {
      this.loadProperties();
    }

    for (let value of this.message) {
      let keyObj = Object.keys(value);
      if (keyObj && keyObj.toString() == resource) {
        return value[keyObj.toString()]
      }
    }
    return null;
  }

}
